import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modal-terms-reposition',
  templateUrl: './modal-terms-reposition.component.html',
  styleUrls: ['./modal-terms-reposition.component.css']
})
export class ModalTermsRepositionComponent implements OnInit {
  bodyTranslation: string
  constructor(public dialogRef: MatDialogRef<ModalTermsRepositionComponent>, private translate: TranslateService) { }

  Accept(){
    this.dialogRef.close(true);
  }
  Close(){
    this.dialogRef.close(false);
  }
  ngOnInit(){
    this.translate.get('terms-conditions.replacement-card-request').subscribe((data: any) => {
      if (!(data === null || data === undefined)) {
        this.bodyTranslation = data.split('\n');
      }
    });
  }
}
